import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'OCORRENCIA_AUTOMATICA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('ocorrenciaAutomaticaForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'OCORRENCIA_AUTOMATICA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'OCORRENCIA_AUTOMATICA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'OCORRENCIA_AUTOMATICA_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

		const dataInicial = getState().ocorrenciaAutomatica.filtro.data_inicial;
		const dataFinal = getState().ocorrenciaAutomatica.filtro.data_final;
		const idsStatus = getState().ocorrenciaAutomatica.filtro.ids_status;
		const idsMotoristas = getState().ocorrenciaAutomatica.filtro.ids_motoristas;
		const idsUsuariosKmm = getState().ocorrenciaAutomatica.filtro.ids_usuarios_kmm;

    	axios.get(`${consts.API_URL}/ocorrenciaAutomatica?
			data_inicial=${dataInicial}
			&data_final=${dataFinal}
			${idsStatus ? idsStatus.map(item => `&ids_status=${item}`).join('') : ''}
			${idsMotoristas ? idsMotoristas.map(item => `&ids_motoristas=${item}`).join('') : ''}
			${idsUsuariosKmm ? idsUsuariosKmm.map(item => `&ids_usuarios_kmm=${item}`).join('') : ''}
		`).then(resp => {
			dispatch({
		        type: 'OCORRENCIA_AUTOMATICA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return async (dispatch, getState) => {

		axios.put(`${consts.API_URL}/ocorrenciaAutomatica`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');

			if (registro.listaValidarLote && registro.listaValidarLote.length) {
				dispatch(setModoTela('validacao', {
					...registro.listaValidarLote[0],
					listaValidarLote: registro.listaValidarLote.slice(1),
					totalLote: registro.totalLote,
					executandoLote: registro.executandoLote + 1
				}));
				dispatch(initForm({
					...registro.listaValidarLote[0],
					listaValidarLote: registro.listaValidarLote.slice(1),
					totalLote: registro.totalLote,
					executandoLote: registro.executandoLote + 1
				}));
			} else {
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}
		}).catch(e => {
			setErroAPI(e);
		});

    };
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/ocorrenciaAutomatica?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}${registro.permite_lancar_periodo_fechado ? '&permite_lancar_periodo_fechado=true' : ''}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			if (evento) {
				evento();
			}
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/ocorrenciaTipo/listarSelect?todos=true`);
    return {
        type: 'OCORRENCIA_AUTOMATICA_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'OCORRENCIA_AUTOMATICA_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuarioKmm() {
    const request = axios.get(`${consts.API_URL}/ocorrenciaAutomatica/listarUsuarioKmmSelect`);
    return {
        type: 'OCORRENCIA_AUTOMATICA_USUARIO_KMM_SELECT_LISTADO',
        payload: request
    };
}